import { useCallback } from 'react';

import { ToastType } from '@components/ui/Toast';
import { useToast } from '@hooks/app/useToast';
import { getAllFieldVisitsNotesWithDexie, getAllFieldVisitsWithDexie, getAllHistoricalFieldVisitsProgressWithDexie, getAllHistoricalFieldVisitsWithDexie } from '@services/local';
import { useCreateHelpDeskTicket } from '@hooks/useCreateHelpDeskTicket';

export const useExportLocalData = () => {
  const showToast = useToast();

   const [createHelpDeskTicketState, createHelpDeskTicket] = useCreateHelpDeskTicket();

  return useCallback(async () => {
    try {
      const visits = await getAllFieldVisitsWithDexie();
      const historicalVisits = await getAllHistoricalFieldVisitsWithDexie().catch(error => {

        console.error("Unable to fetch historical visits", error)
        return null
      })
      const historicalVisitsProgress = await getAllHistoricalFieldVisitsProgressWithDexie().catch(error => {

        console.error("Unable to fetch historical visits progress", error)
        return null
      })

      
      const notes = await getAllFieldVisitsNotesWithDexie();
      const payload = { visits, notes, historicalVisits, historicalVisitsProgress };
      let apiError = false
      try {

        const localDataFile = new File(
            [JSON.stringify(payload, null, 2)],
            'local-data.json',
            { type: 'application/json' }
        );

        await createHelpDeskTicket('Local Data Auto Upload', [localDataFile]);
      } catch(error) {
        console.error("An error occured during auto upload of export data", error)
        apiError = true
      }
      const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(payload))}`;
      const link = document.createElement('a');
      link.href = jsonString;
      link.download = 'local-unsync-data.json';
      link.click();
      if (!apiError) {
        showToast({ type: ToastType.SUCCESS, children: `Data exported successfully.` });
      } else {
        throw new Error("unable to send auto export")
      }
      

      
    } catch (error) {
      showToast({ type: ToastType.ERROR, children: `Ups! Data couldn't be exported. Please, try again.` });
      console.log(error);
    }
  }, [showToast]);
};
